import { useState, useRef } from 'react';
import { Row, Col, Popover, Form, Image, Dropdown, Tooltip, OverlayTrigger, Button, Table, Modal } from 'react-bootstrap';
import accountnamelogo from '../../../assets/images/Account-name-icon-svg.svg';
import bankbuildinglogo from '../../../assets/images/bank-building-svg.svg';
import bankbalancelogo from '../../../assets/images/bank-balance-svg.svg';
import eyeIcon from '../../../assets/images/Action-Icons/Eye-Icon.svg'
import circleCheckWhite from '../../../assets/images/Icons/circleCheckWhite.svg';
import plaidwhitelogo from "../../../assets/images/logo/plaid_white_logo.svg";
import RefreshIcon from '../../../assets/images/TableFilters/TableFilterRefreshIcon.svg';
import InfoIcon from '../../../assets/images/info-icon-v2.svg';
import BankDocumentPopup from "../../Shared/common/components/Modalpopups/BankDocuments/BankDocumentPopup";
import fileDownloadIcon from '../../../assets/images/Action-Icons/Download-Icon.svg';
import deleteIcon from '../../../assets/images/Icons/deleteIcon.svg'
import EditIcon from '../../../assets/images/Action-Icons/Border-Edit-Icon.svg';
import AshCommentsIcon from '../../../assets/images/ash-comments-icon.svg';
import WhiteCommentsIcon from '../../../assets/images/Popup-Icons/PopupIcons_Comments_icon_White.svg';
import ViewDailyBalanceIcon from "../../../assets/images/Popup-Icons/PopupIcons_View_Daily_Balance_Grey.svg";
import viewTransactionIcon from "../../../assets/images/Popup-Icons/PopupIcons_View_Transaction_Grey.svg";
import PopupIcon from '../../../assets/images/Popup-Icons/PopupIcons_AuditInformation_White.svg'
import NotesViewIcon from '../../../assets/images/Icons/Notes-table-view-icon.svg'
import { Trash2, AlertTriangle, X, MoreVertical } from 'lucide-react';
import React, { useEffect } from 'react';
import { convertToBaseFormatDate, currencifyInDollars, fileToBase64, viewDocument, downloadFile, viewNotesformatter, MaskAccountNumber, checkFileFormat, payloadFileFormat } from '../../../commonservices/CommonMethods';
import PlaidData from '../../Plaid/Link';
import ReconnectPlaid from '../../Plaid/ReconnectBank';
import deleteLogo from '../../../assets/images/Icons/deleteIcon.svg'
import AddCircleIcon from '../../../assets/images/Icons/add-circle-icon.svg'
import CustomCheckBox from '../common/components/Shared_FormControls/CustomCheckBox/CustomCheckBox';
import BankInformationPopup from '../BankInformationPopup/BankInformationPopup';
import callAPI from '../../../commonservices/APIRequests';
import Toaster from '../Toaster/Toaster';
import Loader from '../Loader/Loader';
import * as actionCreator from '../../../store/Actions/Actions';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPopup from '../common/components/Modalpopups/ConfirmationPopup/ConfirmationPopup';
import SharedBankDailyBalance from "../../Shared/BankDailyBalnceSharedModule/BankDailyBalnceSharedModule";
import SharedBankTransaction from "../../Shared/BankTransactionSharedModule/BankTransactionSharedModule";
import NoDataFound from '../common/components/TableComponents/NoDataFound/NoDataFound';
import TextAreaField from '../common/components/Shared_FormControls/TextAreaField/TextAreaField';
import CreateBankAccountPopup from '../common/components/Modalpopups/CreateBankAccountPopup/CreateBankAccountPopup';
import { updateBankPayment } from '../../../store/Reducers/BankDetails';
import { hideLoader } from '../../../store/Reducers/Shared';


const BankSelection = (props) => {
    const sharedReducerData = useSelector((store) => store.sharedReducer);
    const dispatch = useDispatch();
    const { isLoaded, lenderSelectedDealerDetails } = useSelector(state => state.sharedReducer);
    const [loader, setLoader] = useState(false)
    const [dealerBanksChecked, setDealerBanksChecked] = useState(false);
    const userDetails = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    const isLender = userDetails?.organization?.toLowerCase() === 'lender';
    const isRsm = userDetails?.role?.toLowerCase() === 'rsm';
    const partnerDetails = localStorage.getItem('partnerDetails') ? JSON.parse(localStorage.getItem('partnerDetails')) : {};
    const [data, setData] = useState(props?.paymentDetails?.banksList ?? []);
    const [dealerData, setDealerData] = useState([]);
    const [bankInfoData, setBankInfoData] = useState({});
    const sampleDocument = useSelector((store) => store.sharedReducer?.masterData?.sampleBankDocuments)
    const [selectedAccountId, setSelectedAccountId] = useState('');
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [selectedDealerData, setSelectedDealerData] = useState({})
    const [showTransModal, setShowModal] = useState(false);
    const [showConfirmationForComment, setShowModalForComment] = useState(false);
    const [commentValidate, setCommentValidate] = useState(true);
    const [commentModalState, setCommentModalState] = useState({
        showModal: false,
        index: '',
        commentText: '',
        bankId: '',
        masked: true
    });
    const [addBankModal, setAddBankModal] = useState(false);
    const [toaster, setToaster] = useState({
        header: '',
        class: '',
        content: '',
        showToaster: false
    })

    const toasterClose = () => {
        setToaster({
            header: '',
            class: '',
            content: '',
            showToaster: false
        })

    }
    const [bankDocumentModal, setBankDocumentModal] = useState({
        bankId: "",
        status: false
    });
    const [confirmationPopupState, setConfirmationPopupState] = useState({
        data: '',
        showPopup: false
    });
    const bankData = useSelector((store) => store.bankdetailsReducer);

    useEffect(() => {
        const paymentDetails = props?.paymentDetails;
        const isDealer = props?.isDealer;
        const accounts = paymentDetails?.accounts;

        if (accounts && isDealer) {
            const filterData = accounts.filter(value => value?.isBankVisible === true && !value.account?.accountNumber?.includes("Cash"));

            if (filterData.length > 0 && !isLender) {
                setDealerData(filterData);
            } else if ((isLender)) {
                setDealerData(accounts);
            }
        }
        dispatch(hideLoader());
    }, [props?.paymentDetails?.accounts])

    useEffect(() => {
        if (props && props.bankData && props.bankData.accounts && props.bankData.accounts.length > 0) {
            setDealerData(props.bankData.accounts);
        }
    }, [props.bankData])


    useEffect(() => {
        if (localStorage.getItem('token') && !sampleDocument.length) {
            dispatch(actionCreator.getSampleBankDocuments());
        }
    }, [sampleDocument])
    const MaskOrUnmaskAccountNumber = (index, maskFlag) => {
        let dealerDataCopy = JSON.parse(JSON.stringify(dealerData));
        dealerDataCopy?.forEach((value, dealerDataCopyIndex) => {
            if (dealerDataCopyIndex === index) {
                value.unmask = maskFlag;
            }

        });

        setDealerData(dealerDataCopy)
    }

    const closeDailyBalancePopup = () => {

        setConfirmationPopupState({ data: '', showPopup: false })
        setSelectedDealerData({});
    }


    const onItemsChecked = (id, checked) => {
        const tableDataCopy = JSON.parse(JSON.stringify(dealerData));
        const checkDataExists = tableDataCopy && tableDataCopy.length > 0 ? tableDataCopy.findIndex(value => value._id === id) : -1
        if (checkDataExists > -1 && (!tableDataCopy[checkDataExists].isPrimary || !tableDataCopy[checkDataExists].isBankVisible)) {
            if (!dealerBanksChecked) setDealerBanksChecked(true);
            tableDataCopy[checkDataExists].isBankVisible = checked
        }
        setDealerData(tableDataCopy)
    }

    const onSubmitDealersChecked = (event) => {
        const req = dealerData && dealerData.length > 0 ? dealerData.map((value) => {
            return {
                _id: value._id,
                isBankVisible: value.isBankVisible
            }
        }) : []
        dealerBankChecked(event, req);
    }

    const dealerBankChecked = (event, reqData) => {
        setLoader(true);
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }


        return callAPI.post('/payment/api/v1/plaid/selectBanksToVisible', reqData)
            .then((response) => {
                if (response.status === 200) {
                    setDealerBanksChecked(false);
                    setToaster({
                        header: 'Success',
                        class: 'success-toaster',
                        content: 'Bank visibility updated successfully',
                        showToaster: true
                    });
                    if (props.closeModalPopup) {
                        props.closeModalPopup();
                    }
                    else {
                        props.refreshBankData();
                    }
                }
                else {
                    setToaster({
                        showToaster: true,
                        content: response.message,
                        header: 'Error',
                        class: 'error-toaster'
                    });
                }
            }).finally(() => {
                setLoader(false);
            })
    }

    const onCancelDealersChecked = () => {
        if (dealerBanksChecked) {
            setDealerBanksChecked(false);
            const accountsToSet = props?.paymentDetails?.accounts || props?.bankData?.accounts;
            setDealerData(accountsToSet);
        } else if (props.closeModalPopup) {
            props.closeModalPopup();
        }

    }

    const cancel = () => {
        setShowModal(false);
        setSelectedDealerData({});
    }

    const onFileChange = async (event, accountData, index, type, list) => {

        let tempDealerData = [],
            file = event.target.files[0]
        if (list === 2) {
            tempDealerData = JSON.parse(JSON.stringify(dealerData));
        }
        else {
            tempDealerData = JSON.parse(JSON.stringify(data));
        }


        if (file.size > 10485760) {
            setToaster({
                header: 'Error',
                class: 'error-toaster',
                content: 'File size is too large, please upload a file smaller than 10MB.',
                showToaster: true
            });
            return;
        }
        const isValid = checkFileFormat(file, setToaster, ['.pdf', '.jpg', '.jpeg', '.png', '.heic']);

        if (!isValid) {
            // Stop further execution because the file format is invalid
            return;
        }
        let achForm = {}, voidedCheck = {}, req = {}
        setLoader(true)
        const fileDetail = {
            fileName: file.name,
            base64Image: await fileToBase64(file),
            fileType: payloadFileFormat(file.name, file.type),
            fileIndex: index,
            documentType: type
        };

        if (type !== "bankVoidedCheck") {
            achForm = {
                fileName: file.name,
                base64Image: await fileToBase64(file),
                fileType: payloadFileFormat(file.name, file.type)
            }
            req = {
                dealer_id: accountData.userId,
                bankId: accountData?._id ?? accountData?.id,
                achForm
            }
        } else {
            voidedCheck = {
                fileName: file.name,
                base64Image: await fileToBase64(file),
                fileType: payloadFileFormat(file.name, file.type)
            }
            req = {
                dealer_id: accountData.userId,
                bankId: accountData?._id ?? accountData?.id,
                voidedCheck
            }
        }

        return callAPI.post('/payment/api/v1/payments/saveBankDetails', req)
            .then((response) => {
                if (response.status === 200) {

                    dispatch(actionCreator.getBankList(req.dealer_id, '', false, props.from));

                    setLoader(false)
                } else {
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    })
                    setLoader(false)
                }
            })
    }

    const onFileDelete = (event, docuemntIndex, documentId, list, type) => {
        if (event) {
            event.preventDefault()
            event.stopPropagation()
        }


        let tempDealerData = [];
        if (list === 2) {
            tempDealerData = JSON.parse(JSON.stringify(dealerData));
        }
        else {
            tempDealerData = JSON.parse(JSON.stringify(data));
        }
        const req = {
            documentId
        }
        setLoader(true)

        return callAPI.post('/payment/api/v1/payments/deleteBankDocument', req)
            .then((response) => {
                if (response.status === 200) {
                    let fileName = (type !== "bankVoidedCheck") ? 'ACH Form' : 'Voided Check'
                    dispatch(actionCreator.getBankList((props.supplierId ? props.supplierId : props?.selectedDealerId), '', false, props.from));
                    setLoader(false)
                } else {
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    })
                    setLoader(false)
                }
            })
    }

    const getDocument = (event, document) => {
        if (event) {
            event.preventDefault()
            event.stopPropagation()
        }
        setLoader(true);

        return callAPI.get('/lender/api/v1/dealer/getDocument', { documentId: document })
            .then((response) => {

                if (response.status === 200) {
                    viewDocument(response.data.fileType, response.data.url)
                    setLoader(false);

                }
                else {
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    });
                    setLoader(false);

                }

            })

    }

    const updateBankModal = (item, type) => {
        props.updateBankDetails(item, type)
    }

    const removeBankConfirmation = (id) => {
        setSelectedAccountId(id);
        if (props.isEdit)
            props.deleteBankinView(id)
        else
            setShowConfirmation(true);
    }
    const removeBankCancel = () => {
        setShowConfirmation(false);
        setSelectedAccountId('');
    }

    const deleteBankAccount = async (id) => {
        setLoader(true);
        const req = {
            _id: id
        }
        if (props.supplierBankWidget) {
            req.supplier_id = props.supplierId
        } else {

            if (sharedReducerData.lenderSelectedDealerId) {
                req.dealer_id = sharedReducerData.lenderSelectedDealerId
            }
            else {
                req.dealer_id = props?.selectedDealerId
            }
        }

        return callAPI.post('/payment/api/v1/payments/deleteBankAccount', req)
            .then(async (response) => {
                if (response.status === 200) {
                    if (props.supplierBankWidget) {
                        await dispatch(actionCreator.getBankList(props.supplierId, '', false, props.from));
                    } else {
                        await dispatch(actionCreator.getBankList(req?.dealer_id, '', false, props.from));
                    }
                    removeBankCancel();
                    setLoader(false);
                    setToaster({
                        header: 'Success',
                        class: 'success-toaster',
                        content: 'Bank account deleted successfully.',
                        showToaster: true
                    });


                }
                else {
                    setLoader(false);
                    removeBankCancel();
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    })
                }

            })

    }

    const showDailyBalanceHandler = (event, item) => {

        setConfirmationPopupState({
            data: item,
            showPopup: true
        })
        let bankName = item?.account?.bankName ?? item?.bankName
        let bankaccountNumber = item?.account?.accountNumber ?? item?.accountNumber
        if (item)
            setSelectedDealerData({
                ...selectedDealerData,
                dealerName: props?.selectedDealerName ?? lenderSelectedDealerDetails.dealerName ?? userDetails.dealerName,
                dealerId: props?.selectedDealerId ?? lenderSelectedDealerDetails._id ?? userDetails._id,
                dealerReference: props?.selectedDealerReference ?? lenderSelectedDealerDetails.sopraDealerReference ?? userDetails.sopraDealerReference,
                bankName: `${bankName} (${bankaccountNumber})`,
                bankId: item.bankId ?? item?._id ?? item.id
            })
    }

    const showTransation = (event, item) => {
        setShowModal(true);
        let bankName = item?.account?.bankName ?? item?.bankName
        let bankaccountNumber = item?.account?.accountNumber ?? item?.accountNumber
        if (item)
            setSelectedDealerData({
                ...selectedDealerData,
                dealerName: props?.selectedDealerName ?? lenderSelectedDealerDetails.dealerName ?? userDetails.dealerName,
                dealerId: props?.selectedDealerId ?? lenderSelectedDealerDetails._id ?? userDetails._id,
                dealerReference: props?.selectedDealerReference ?? lenderSelectedDealerDetails.sopraDealerReference ?? userDetails.sopraDealerReference,
                bankName: `${bankName} (${bankaccountNumber})`,
                bankId: item.bankId ?? item?._id ?? item.id
            })
    }

    //Bank comment feature code here
    const commentHandler = (index, item, actionName = '') => {
        setCommentModalState({
            ...commentModalState,
            showModal: true,
            commentText: item.comment,
            bankName: item?.account?.bankName,
            accountNumber: item?.account?.accountNumber,
            index: index,
            bankId: item._id,
            action: actionName,
        })

        // if (actionName === 'delete')
        //     setShowModalForComment(true)
    }
    const showDeleteComment = (event) => {
        setCommentModalState({
            ...commentModalState,
            showModal: false,
            commentText: '',
        })
        setShowModalForComment(true)
    }
    const commentActionHandler = (event) => {
        event.preventDefault()
        event.stopPropagation()

        let req = {
            bankId: commentModalState?.bankId,
            comment: commentModalState?.commentText
        }

        let validate = true
        if (commentModalState?.action === 'add') {
            validate = commentModalState.commentText ? true : false
            setCommentValidate(commentModalState.commentText ? true : false)
        }

        if (validate) {
            setLoader(true);
            return callAPI.post('/lender/api/v1/lender/saveBankComments', req)
                .then((response) => {
                    if (response.status === 200) {
                        dispatch(actionCreator.getBankList((props?.supplierId ?? props?.selectedDealerId ?? lenderSelectedDealerDetails._id ?? userDetails._id), '', false, props.from));
                        setCommentModalState({
                            showModal: false,
                            index: '',
                            commentText: '',
                            bankId: ''
                        })
                        setLoader(false);
                        setShowModalForComment(false)
                    }
                    else {
                        setToaster({
                            header: 'Error',
                            class: 'error-toaster',
                            content: response.message,
                            showToaster: true
                        });
                        setLoader(false);
                        setShowModalForComment(false)
                    }

                })
        }

    }

    const cancelDeleteComment = () => {
        setShowModalForComment(false)
        setCommentValidate(true)
        setCommentModalState({
            showModal: false,
            commentText: '',
            index: '',
            bankId: '',
            action: ''
        })
    }


    const refreshBankAccounts = () => {

        dispatch(actionCreator.getBankList((sharedReducerData.lenderSelectedDealerId ? sharedReducerData.lenderSelectedDealerId : props?.selectedDealerId ? props?.selectedDealerId : sharedReducerData?.lenderSelectedSupplierDetails?._id), '', false, props.from))
    }

    const onClickAddBankAccount = () => {

        if (props?.onClickAddBankAccount) {
            props.onClickAddBankAccount()
        }
        else {
            setAddBankModal(true)
        }
    }


    const updateBalance = async (event, refreshBankId, index) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        let tempData = JSON.parse(JSON.stringify(bankData?.bankpaymentData));
        tempData.accounts[index].flip = true;
        dispatch(updateBankPayment(tempData));
        const req = {
            bankId: refreshBankId
        }
        return callAPI.post('/payment/api/v1/plaid/refreshBalance', req)
            .then((response) => {

                if (response.status === 200) {

                    setToaster({
                        header: 'Success',
                        class: 'success-toaster',
                        content: 'Bank details refreshed successfully.',
                        showToaster: true
                    });
                    const tempData = JSON.parse(JSON.stringify(bankData?.bankpaymentData));
                    tempData?.accounts?.forEach((value) => {
                        if (value._id === refreshBankId) {
                            value.flip = false
                        }

                    });
                    dispatch(updateBankPayment(tempData));

                    dispatch(actionCreator.getBankList(sharedReducerData.lenderSelectedDealerId ? sharedReducerData.lenderSelectedDealerId : props?.selectedDealerId, refreshBankId, true, props.from));
                }
                else {
                    const tempData = JSON.parse(JSON.stringify(bankData?.bankpaymentData));
                    tempData?.accounts?.forEach((value) => {
                        if (value._id === refreshBankId) {
                            value.flip = false
                            value.plaidError = response.message ? response.message : '';
                        }
                    });

                    dispatch(updateBankPayment(tempData));
                    let errMessage = '';
                    if (response && response.message) {
                        errMessage = response.message
                    }
                    else {
                        errMessage = 'Something went wrong.'
                    }

                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: errMessage,
                        showToaster: true
                    });
                }
            });
    }

    const updateCommentHandler = (key, value) => {
        setCommentModalState({
            ...commentModalState,
            commentText: value
        });
        if (value)
            setCommentValidate(true)
        else
            setCommentValidate(false)
    }

    return (
        <div className='banklist-selection-wrapper page-without-info-widgets'>
            <Row className={`mx-0 profile-tab-header align-items-center justify-content-between ${!props?.showHeaderBank ? 'p-0' : ''}`}>
                <Col className="p-0" xs={props.showHeaderBank ? 6 : 9}>
                    {props.labelShow ? <h6 className="content-text-color widget-title plaid-head-font">External Bank Accounts</h6> : null}
                    {props.showHeaderBank ?
                        <p className="content-text-color mb-0">Add all your bank accounts</p>
                        : ''}
                </Col>
                {props.showHeaderBank && (userDetails && userDetails.organization?.toLowerCase() !== "lender") ?
                    <React.Fragment>
                        <Col xs={3} className="p-0 text-right newPlaidBtnCol">

                            <PlaidData
                                setModalLoader={(status) => props.setModalLoader(status)}
                                initiateLoader={props.initiateLoader}
                                closeLoader={props.closeLoader}
                                addBankAccount={props.addBankAccount}
                                setDocumentModal={(status) => setBankDocumentModal(status)}

                            >
                            </PlaidData>
                        </Col>
                    </React.Fragment>
                    :
                    props.showHeaderBank && (userDetails && userDetails.organization?.toLowerCase() === "lender") ?
                        <Button variant="primary" className="default-btn ml-auto mr-3"
                            onClick={(event) => onClickAddBankAccount()}>
                            Add New Bank Account
                        </Button>
                        : null}
            </Row>

            <div className='table_scroller'>
                <Loader show={loader || !sharedReducerData?.isLoaded} styleType='absolute' />
                {
                    toaster.showToaster ?
                        <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
                        : null
                }
                <Table responsive className="soldinventory-table mb-0 default-table">
                    <thead className='table-header-bg-color'>
                        {(isLender && !isRsm) && !props?.showHeaderBank ? <th className='active-check-in-table'>Active</th> : null}
                        <th className='account-name-in-table'>Account Name</th>
                        <th className='account-number-in-table'>Account Number</th>
                        <th className='account-balance-in-table'>Balance</th>
                        <th className='ach-form-in-table'>ACH Form <OverlayTrigger key="right" placement="bottom-start"
                            overlay={
                                <Popover>
                                    <Popover.Content>
                                        <span>Allowed types: PDF, JPG, JPEG, PNG, HEIC</span>
                                    </Popover.Content>
                                </Popover>
                            }>
                            <Image src={InfoIcon} alt='info' className='common-info-icon ml-1 file-info-icon' />
                        </OverlayTrigger></th>
                        <th className='voided-check-in-table'>Voided Check <OverlayTrigger key="right" placement="bottom-start"
                            overlay={
                                <Popover>
                                    <Popover.Content>
                                        <span>Allowed types: PDF, JPG, JPEG, PNG, HEIC</span>
                                    </Popover.Content>
                                </Popover>
                            }>
                            <Image src={InfoIcon} alt='info' className='common-info-icon ml-1 file-info-icon' />
                        </OverlayTrigger></th>
                        {!props.isOnboard && <th className='primary-bank-in-table'>Primary</th>}
                        {(!isRsm && isLender) ? <th className='plaid-status-in-table'>Comments</th> : null}
                        {!props.isOnboard && !userDetails.readOnlyAccess && !isRsm && isLender && <th>Actions</th>}
                    </thead>
                    {
                        dealerData && dealerData.length > 0 ?
                            <tbody>
                                {
                                    dealerData.map((account, index) => {
                                        return (
                                            <>
                                                <tr className={`${account.bankErrorMessage && (partnerDetails && partnerDetails.enablePlaid ? 'hide-border-bottom' : '')} mx-0 external-bank-list`} key={'bankAccounts' + index} >

                                                    {/* ACTIVE Bank Column */}
                                                    {
                                                        (isLender && !isRsm) && !props?.showHeaderBank ?
                                                            <td>
                                                                <CustomCheckBox
                                                                    checked={account?.isBankVisible}
                                                                    objectKey="search"
                                                                    onChange={(key, checked,) => {
                                                                        onItemsChecked(account._id, checked)
                                                                    }}
                                                                />
                                                            </td> : null
                                                    }
                                                    {/* Account Name Column */}
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            {account?.account?.logo ? <Image className="bank-logo mt-0 mr-1" width={40} src={`data:image/jpeg;base64,${account?.account?.logo}`} /> : ''}
                                                            <div>
                                                                {account?.account?.name ? <b className='mr-1'>{account?.account?.name}</b> : (account?.account?.bankName ? <b className='mr-1'>{account?.account?.bankName}</b> : '')}
                                                                {(isLender && !isRsm) ? (
                                                                    (account.account?.account_id || account?.bankErrorMessage) ?
                                                                        <span>
                                                                            <OverlayTrigger placement="bottom"
                                                                                overlay={
                                                                                    <Tooltip>View Bank Info</Tooltip>}>
                                                                                <Image src={InfoIcon} className="ml-0 bank-rotate-refresh cursor-pointer" onClick={(event) => {
                                                                                    props.showBankInfo(account);
                                                                                }} />
                                                                            </OverlayTrigger>
                                                                        </span>
                                                                        : '') : null
                                                                }
                                                            </div>
                                                        </div>
                                                        {
                                                            account?.bankStatus === 'Pending' ?
                                                                <div>
                                                                    <small className=' mr-1 d-inline'>Status: {account?.bankStatus}</small>
                                                                    <span className='d-inline'>
                                                                        <OverlayTrigger placement="bottom"
                                                                            overlay={
                                                                                <Tooltip>The bank will be approved after ACH form & Voided check documents verification.</Tooltip>}>
                                                                            <Image src={InfoIcon} className="common-info-icon cursor-pointer" />
                                                                        </OverlayTrigger>
                                                                    </span>
                                                                </div>
                                                                : null
                                                        }
                                                        {
                                                            !props.isDealer && (account?.bankStatus !== "Pending") && account.account &&
                                                                account.account.account_id &&
                                                                !account.bankErrorMessage ? (
                                                                <div className="d-flex align-items-center">
                                                                    <small className='mr-1'>Display:</small>
                                                                    <Form.Check
                                                                        type="switch"
                                                                        className='default-switch-button'
                                                                        id={account?.account_id}
                                                                        checked={account?.previewBalance}
                                                                        onChange={(event) => { props.onSelectUpdatePreviewBank(account?._id, (account?.account?.balances?.available ?? account?.account?.balances?.current ?? '0.00'), account.balanceUpdatedon, event.target.checked, event) }}
                                                                    />
                                                                </div>
                                                            ) : null
                                                        }
                                                        {(isLender && !isRsm) && account.hasOwnProperty("mergeBankHistoryId") && Object.keys(account?.mergeBankHistoryId).length > 0 ?
                                                            <div>
                                                                <small className=' mr-1 d-inline'>Merged:</small>
                                                                <OverlayTrigger placement="bottom"
                                                                    overlay={
                                                                        <Tooltip>View Merge Details</Tooltip>}>
                                                                    <Image src={InfoIcon} className="ml-0 bank-rotate-refresh cursor-pointer" onClick={(event) => {
                                                                        props.showMergeBankInfo(account?.mergeBankHistoryId);
                                                                    }} />
                                                                </OverlayTrigger>
                                                            </div>
                                                            : ''
                                                        }
                                                    </td>
                                                    {/* Account Number Column */}
                                                    <td>
                                                        <b>{MaskAccountNumber(!account?.unmask, account?.account?.accountNumber)}
                                                            <span>
                                                                <OverlayTrigger placement="bottom"
                                                                    overlay={
                                                                        <Tooltip>View {!account?.unmask ? 'unmasked' : 'masked'} account number.</Tooltip>}>
                                                                    <Image src={InfoIcon} className="ml-0 ml-2 bank-rotate-refresh cursor-pointer" onClick={(event) => {
                                                                        !account?.unmask ? MaskOrUnmaskAccountNumber(index, true) : MaskOrUnmaskAccountNumber(index, false);
                                                                    }} />
                                                                </OverlayTrigger>
                                                            </span>
                                                        </b>
                                                        {!props.supplierBankWidget && !userDetails.readOnlyAccess ?
                                                            <div className='mt-2'>
                                                                {
                                                                    account.account &&
                                                                        account.account.account_id &&
                                                                        !account.bankErrorMessage ?
                                                                        <Button variant="success" className="default-btn plaid-success-btn">
                                                                            <Image className="mr-1 plaid-checked-icon" height={14} src={circleCheckWhite} alt='checked' />
                                                                            Connected to
                                                                            <Image className="ml-1 plaid-icon" src={plaidwhitelogo} height={14} />
                                                                        </Button>
                                                                        : account?.account?.account_id && account.bankErrorMessage && (partnerDetails && partnerDetails.enablePlaid) && !account.bankErrorMessage.includes("INSTITUTION_NOT_RESPONDING") && !account.bankErrorMessage.includes("ITEM_NOT_FOUND") && userDetails?.organization?.toLowerCase() !== 'lender' ?

                                                                            <ReconnectPlaid
                                                                                bankID={account._id}
                                                                                className="auto-width-btn"
                                                                                updateBanks={() => dispatch(actionCreator.getBankList())}
                                                                                setModalLoader={(status) => props.setModalLoader(status)}
                                                                            >
                                                                            </ReconnectPlaid>
                                                                            : null}
                                                            </div>
                                                            : null}
                                                    </td>
                                                    {/* Account Balance Column */}
                                                    <td>
                                                        {account.account.balances ? (
                                                            <p>
                                                                <span className="dealer-bankDetails-amount">
                                                                    {currencifyInDollars(account.account.balances && +account.account.balances.available ? account.account.balances.available : (account.account.balances && +account.account.balances.current ? account.account.balances.current : '0.00'))}
                                                                </span>

                                                                {
                                                                    (!isRsm && isLender) ?
                                                                        account.account?.bankName && account?.flip ?
                                                                            <span>
                                                                                <Image src={RefreshIcon} className="bank-rotate-refresh cursor-pointer rotate-icon" />

                                                                            </span>
                                                                            : account?.account?.bankName ?
                                                                                <span>
                                                                                    <OverlayTrigger placement="bottom"
                                                                                        overlay={
                                                                                            <Tooltip>Refresh Bank Details</Tooltip>}>
                                                                                        <Image src={RefreshIcon} className="bank-rotate-refresh cursor-pointer" onClick={(event) => { updateBalance(event, account?._id, index); setDealerBanksChecked(false) }} />
                                                                                    </OverlayTrigger>
                                                                                </span>
                                                                                : ''
                                                                        : null
                                                                }
                                                                {
                                                                    !isRsm && isLender ? (account?.balanceUpdatedon ?
                                                                        <small>{convertToBaseFormatDate(account?.balanceUpdatedon, true, true)}</small>
                                                                        : '') : null
                                                                }

                                                                {!account?.bankId && account?.disablePlaidRequiredAction === true && account?.showPlaidBanner === false ?
                                                                    <small>Banner Status: Disabled</small>
                                                                    : null}

                                                                {account?.plaidError ?
                                                                    <small className="paymentfailed-task-text-color">{account.plaidError}</small>
                                                                    : ''}

                                                            </p>)
                                                            : <p>-NA-</p>
                                                        }
                                                    </td>
                                                    {/* ACH Form Column */}
                                                    <td>
                                                        {
                                                            (account?.documents?.filter((value) => value?.documentType === "bankAchForm").length > 0) ? (account?.documents.filter((value) => value?.documentType === "bankAchForm").map((el, id) =>
                                                                <b className='ach-form-file-in-table'>{el?.fileName && 'ACHForm'}
                                                                    <OverlayTrigger placement="bottom"
                                                                        overlay={
                                                                            <Tooltip>View</Tooltip>}>
                                                                        <Image src={eyeIcon} className='cursor-pointer eyeIcon-in-table ml-1' onClick={(event) => getDocument(event, el?._id)} />
                                                                    </OverlayTrigger>
                                                                    {!userDetails.readOnlyAccess ? <OverlayTrigger placement="bottom"
                                                                        overlay={
                                                                            <Tooltip>Delete</Tooltip>}>
                                                                        <Image src={deleteIcon} className="ml-1 cursor-pointer delete-icon" onClick={(event) => onFileDelete(event, index, el?._id, 2)} />
                                                                    </OverlayTrigger> : null}
                                                                </b>
                                                            )) : (
                                                                <div>
                                                                    <span className='d-flex' onClick={() => downloadFile(sampleDocument.find((doc) => doc.label === "bankAchForm").value, "bankAchForm.png")}>
                                                                        <small className='mr-1 d-inline'>Sample File</small>
                                                                        <OverlayTrigger placement="bottom"
                                                                            overlay={
                                                                                <Tooltip>Download</Tooltip>}>
                                                                            <Image className="img-14px cursor-pointer d-inline" src={fileDownloadIcon} alt="sample-file-icon" />
                                                                        </OverlayTrigger>
                                                                    </span>
                                                                    {!userDetails.readOnlyAccess ?
                                                                        <label for={'attachfile1' + index} className="cursor-pointer d-flex mb-0">
                                                                            <small className='mr-1'>Add</small>
                                                                            <Image src={AddCircleIcon} className='img-12px' alt="additioncost-image" />
                                                                        </label> : null}
                                                                    <input
                                                                        type="file"
                                                                        id={'attachfile1' + index}
                                                                        className="d-none"
                                                                        onChange={(event) => onFileChange(event, account, index, "bankAchForm", 2)}
                                                                    />
                                                                        
                                                                    <span className='d-flex custom-error-message'>ACH Form is missing</span>
                                                                </div>
                                                            )
                                                        }

                                                    </td>
                                                    {/* Voided Check Column */}
                                                    <td>
                                                        {
                                                            (account?.documents?.filter((value) => value?.documentType === "bankVoidedCheck").length > 0) ? (account?.documents.filter((value) => value?.documentType === "bankVoidedCheck").map((el, id) =>
                                                                <b className='ach-form-file-in-table'>{el?.fileName && 'VoidCheck'}
                                                                    <OverlayTrigger placement="bottom"
                                                                        overlay={
                                                                            <Tooltip>View</Tooltip>}>
                                                                        <Image src={eyeIcon} className='cursor-pointer eyeIcon-in-table ml-1' onClick={(event) => getDocument(event, el?._id)} />
                                                                    </OverlayTrigger>
                                                                    {!userDetails.readOnlyAccess ?
                                                                        <OverlayTrigger placement="bottom"
                                                                            overlay={
                                                                                <Tooltip>Delete</Tooltip>}>
                                                                            <Image src={deleteIcon} className="ml-1 cursor-pointer delete-icon" onClick={(event) => onFileDelete(event, index, el?._id, 2)} />
                                                                        </OverlayTrigger> : null}
                                                                </b>
                                                            )) : (
                                                                <div>
                                                                    <span className='d-flex' onClick={() => downloadFile(sampleDocument.find((doc) => doc.label === "bankVoidedCheck").value, "bankVoidedCheck.jpeg")}>
                                                                        <small className='mr-1 d-inline'>Sample File</small>
                                                                        <OverlayTrigger placement="bottom"
                                                                            overlay={
                                                                                <Tooltip>Download</Tooltip>}>
                                                                            <Image className="cursor-pointer img-14px d-inline" src={fileDownloadIcon} alt="sample-file-icon" />
                                                                        </OverlayTrigger>
                                                                    </span>
                                                                    {!userDetails.readOnlyAccess ? <label for={'attachfile2' + index} className="cursor-pointer d-flex mb-0">
                                                                        <small className='mr-1'>Add</small>
                                                                        <Image src={AddCircleIcon} className='img-12px' alt="additioncost-image" />
                                                                    </label> : null}
                                                                    <input
                                                                        type="file"
                                                                        id={'attachfile2' + index}
                                                                        className="d-none"
                                                                        onChange={(event) => onFileChange(event, account, index, "bankVoidedCheck", 2)}
                                                                    />
                                                                    <span className='d-flex custom-error-message'>Voided Check is missing</span>
                                                                </div>
                                                            )
                                                        }
                                                    </td>
                                                    {
                                                        !props?.isOnboard ? <td>
                                                            {
                                                                (account?.bankStatus === "Pending") ?

                                                                    <OverlayTrigger placement="left"
                                                                        overlay={
                                                                            <Tooltip>Bank Approval Pending</Tooltip>}>
                                                                        <Form.Check
                                                                            type="switch"
                                                                            className='default-switch-button'
                                                                            id={account?.account_id}
                                                                            checked={false}
                                                                            disabled={true}
                                                                        />
                                                                    </OverlayTrigger>

                                                                    : <Form.Check
                                                                        type="switch"
                                                                        className={`default-switch-button ${userDetails.readOnlyAccess && account?.isPrimary ? 'disable-toggle' : ''}`}
                                                                        id={account?.account_id}
                                                                        checked={account?.isPrimary}
                                                                        disabled={!userDetails.readOnlyAccess && !account?.isPrimary ? false : true}
                                                                        onChange={(event) => props.onSelectedFilter(account?._id, account?.isBankVisible, event.target.checked, event)}
                                                                    />
                                                            }


                                                        </td> : null
                                                    }
                                                    {/* Comments Column */}
                                                    {!isRsm && isLender ?
                                                        < td >
                                                            {
                                                                account.comment ?
                                                                    <>
                                                                        {account.comment ?
                                                                            <React.Fragment>
                                                                                <span className='notes-in-table-col'>
                                                                                    <span>{(account.comment && account.comment.length > 60) ? viewNotesformatter(account.comment, true, 0, 60) : viewNotesformatter(account.comment)}</span>
                                                                                    <span className="icon-color cursor-pointer ml-1" >
                                                                                        <OverlayTrigger placement="bottom"
                                                                                            overlay={
                                                                                                <Tooltip>View More</Tooltip>}>
                                                                                            <Image src={NotesViewIcon} onClick={() => commentHandler(index, account)} className='edit-icon-in-table cursor-pointer' />
                                                                                        </OverlayTrigger>
                                                                                    </span>
                                                                                </span>
                                                                            </React.Fragment> : null}
                                                                    </>
                                                                    :
                                                                    <label className="cursor-pointer notes-in-table-col d-flex" onClick={() => commentHandler(index, account, 'add')}>
                                                                        <span className='mr-1'>Add</span>
                                                                        <Image src={AshCommentsIcon} className='img-14px' alt="additioncost-image" />
                                                                    </label>
                                                            }

                                                        </td>
                                                        : null}
                                                    {/* Actions Column */}
                                                    {
                                                        !props?.isOnboard && !userDetails.readOnlyAccess && !isRsm && isLender ?
                                                            <td>
                                                                <React.Fragment>
                                                                    <Dropdown className="default-table-actions-dd">
                                                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                                            <MoreVertical className="cursor-pointer" size={16} />
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu popperConfig={{
                                                                            strategy: "fixed"
                                                                        }}>
                                                                            {props.isEdit ?
                                                                                <Dropdown.Item onClick={() => updateBankModal(account, 'update')} >
                                                                                    <span><Image src={EditIcon} alt='edit' /></span>
                                                                                    <span>Edit</span>
                                                                                </Dropdown.Item>
                                                                                : null}
                                                                            {
                                                                                !account?.isPrimary && (userDetails && userDetails.organization?.toLowerCase() === 'lender') ? <Dropdown.Item onClick={() => removeBankConfirmation(account._id)}>
                                                                                    <span><Image src={deleteIcon} alt='delete' /></span>
                                                                                    <span>Delete</span>
                                                                                </Dropdown.Item> :
                                                                                    <Dropdown.Item>
                                                                                        <span><Image src={deleteIcon} alt='delete' /></span>
                                                                                        <span className='disabled-text'>Delete</span>
                                                                                    </Dropdown.Item>

                                                                            }
                                                                            {
                                                                                (isLender && !isRsm) ?
                                                                                    (account.account?.account_id ?
                                                                                        <>
                                                                                            <Dropdown.Item onClick={(event) => showDailyBalanceHandler(event, account)}>
                                                                                                <span><Image src={ViewDailyBalanceIcon} alt='daily_balance' /></span>
                                                                                                <span>View Daily Balance</span>
                                                                                            </Dropdown.Item>
                                                                                            <Dropdown.Item onClick={(event) => showTransation(event, account)}>
                                                                                                <span><Image src={viewTransactionIcon} alt='daily_balance' /></span>
                                                                                                <span>View Transaction </span>
                                                                                            </Dropdown.Item></>
                                                                                        : null)
                                                                                    : null
                                                                            }

                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </React.Fragment>
                                                            </td> : null
                                                    }
                                                </tr >
                                                {
                                                    account.bankErrorMessage && (partnerDetails && partnerDetails.enablePlaid) ?

                                                        <tr>
                                                            <td colSpan="6" className='pt-0'>
                                                                {account?.bankErrorMessage?.includes("ITEM_NOT_FOUND") ?
                                                                    <p>
                                                                        <AlertTriangle className="red-status-color mr-1" size={14} />
                                                                        <span className="red-status-color">Bank connection removed, please connect to Plaid.</span>
                                                                    </p> :
                                                                    (account?.bankErrorMessage?.includes("INSTITUTION_NOT_RESPONDING") ?
                                                                        <p>
                                                                            <AlertTriangle className="red-status-color mr-1" size={14} />
                                                                            <span className="red-status-color">Bank is currently not responding, please connect to Plaid again to resolve the issue.</span>
                                                                        </p>
                                                                        : <p>
                                                                            <AlertTriangle className="red-status-color mr-1" size={14} />
                                                                            <span className="red-status-color">The login details for this institution are not valid, please reconnect</span>
                                                                        </p>)}
                                                            </td>
                                                        </tr>
                                                        : ''
                                                }
                                            </>
                                        )
                                    })
                                }
                            </tbody> : <tbody>
                                <tr>
                                    <td colSpan={!props?.isOnboard ? 8 : 6}>
                                        <NoDataFound />
                                    </td>
                                </tr>
                            </tbody>
                    }
                </Table>
            </div>
            {
                !props?.showHeaderBank ?
                    <Row className='my-3 mx-0'>
                        {isLender && !isRsm && dealerData && dealerData.length > 0 ?
                            <div className='d-flex justify-content-start modal-action-btns ml-3'>
                                <Button variant="primary" disabled={!dealerBanksChecked} className="default-btn" onClick={(event) => onSubmitDealersChecked(event)}>Submit</Button>
                                <Button variant="outline-secondary" className="default-btn" onClick={(event) => onCancelDealersChecked(event)}>Cancel</Button>
                            </div> : null}
                        {
                            (userDetails?.organization?.toLowerCase() === 'supplier' || (isLender && !isRsm)) && !userDetails.readOnlyAccess && !props.isSupplierApplication && !props?.showHeaderBank && !props.isOnboard ? <Button variant="primary" className="default-btn ml-auto mr-3" onClick={(event) => onClickAddBankAccount()}>Add New Bank Account</Button> : null
                        }
                    </Row> : null
            }
            {
                userDetails && (userDetails.organization?.toLowerCase() === 'dealer' || userDetails.type?.toLowerCase().includes('dealer')) && props?.isDealer && props.showAddbank && (partnerDetails && partnerDetails.enablePlaid) ?
                    <Col xs={12} className="external-connect-plaid mb-3">
                        <PlaidData
                            setModalLoader={(status) => props.setModalLoader(status)}
                            initiateLoader={props.initiateLoader}
                            closeLoader={props.closeLoader}
                            addBankAccount={props.addBankAccount}
                            setDocumentModal={(status) => setBankDocumentModal(status)}
                        >
                        </PlaidData>
                    </Col>
                    : ''
            }

            <ConfirmationPopup
                title="Are you sure want to delete the bank account?"
                onClose={() => removeBankCancel(false)}
                showModal={showConfirmation}
                showPopupLoader={loader}
                primaryActionLabel="Yes"
                secondaryActionLabel="No"
                primaryAction={(event) => { deleteBankAccount(selectedAccountId) }}
                secondaryAction={() => removeBankCancel(false)}
            />

            <ConfirmationPopup
                title="Are you sure want to delete the bank comment?"
                onClose={() => setShowModalForComment(false)}
                showModal={showConfirmationForComment}
                showPopupLoader={loader}
                primaryActionLabel="Yes"
                secondaryActionLabel="No"
                primaryAction={(event) => { commentActionHandler(event) }}
                secondaryAction={() => setShowModalForComment(false)}
            />

            {
                selectedDealerData.dealerId ?
                    <SharedBankDailyBalance
                        dealerName={selectedDealerData.dealerName}
                        dealerReference={selectedDealerData.dealerReference}
                        showModalBDB={confirmationPopupState.showPopup}
                        cancelBDB={closeDailyBalancePopup}
                        bankId={selectedDealerData.bankId}
                        dealerId={selectedDealerData.dealerId}
                        showBankSelection={false}
                    /> : null
            }

            {
                showTransModal ? <SharedBankTransaction
                    showModalBT={showTransModal}
                    cancelBT={cancel}
                    dealerName={selectedDealerData.dealerName}
                    dealerReference={selectedDealerData.dealerReference}
                    bankId={selectedDealerData.bankId}
                    dealerId={selectedDealerData.dealerId}
                    showBankSelection={false}
                /> : null
            }

            <Modal className={`default-popup modal-backdrop-bg-color default-small-popup table-in-popup`} show={commentModalState.showModal}
                onHide={() => cancelDeleteComment()}>
                <Modal.Header className='darkblue-bg-color' closeButton={true}>
                    <Modal.Title>
                        <span className='popup-title-icon'><Image src={WhiteCommentsIcon} /></span>
                        <span className='flex-grow-1'>Bank Comment</span>
                        <span className='popup-close-icon'><X size={20} /></span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Loader show={loader} styleType='absolute' />
                    <div>
                        <b>{commentModalState?.bankName}</b>
                        <b className='d-block'>{MaskAccountNumber(commentModalState?.masked, commentModalState?.accountNumber)}
                            <span>
                                <OverlayTrigger placement="bottom"
                                    overlay={
                                        <Tooltip>View {commentModalState?.masked ? 'unmasked' : 'masked'} account number.</Tooltip>}>
                                    <Image src={InfoIcon} className="ml-0 ml-2 bank-rotate-refresh cursor-pointer" onClick={(event) => {
                                        commentModalState?.masked ? setCommentModalState({ ...commentModalState, masked: false }) : setCommentModalState({ ...commentModalState, masked: true });
                                    }} />
                                </OverlayTrigger>
                            </span>
                        </b>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} xs={12} className='mt-3'>

                                    <TextAreaField
                                        label='Comment'
                                        name="Comment"
                                        value={commentModalState.commentText ? commentModalState.commentText : ''}
                                        objectKey="Comment"
                                        onChange={(key, value) => updateCommentHandler(key, value)}
                                        placeholder="Comment text..."
                                        required
                                    />
                                    {!commentValidate ? <p className='custom-error-message'>Please enter comment.</p> : null}
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Col className="text-xs-center d-flex justify-content-start modal-action-btns mt-3">
                                    <Button type="submit" variant="primary" className="default-btn" onClick={(e) => commentActionHandler(e)}>{!commentModalState.action ? 'Save' : 'Add'}</Button>
                                    {!commentModalState.action ?
                                        <Button type="submit" variant="primary" className="default-btn" onClick={(e) => showDeleteComment(e)}>Delete</Button> : null
                                    }
                                    <Button type="button" variant="outline-secondary" className="default-btn" onClick={() => cancelDeleteComment()}>Cancel</Button>
                                </Col>
                            </Form.Row>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
            {
                bankDocumentModal.status && (
                    <BankDocumentPopup
                        showModal={bankDocumentModal.status}
                        bankId={bankDocumentModal.bankId}
                        addBankAccount={props.addBankAccount}
                        documents={bankDocumentModal.documents}
                        setshowModalPopup={(status) => setBankDocumentModal({ status: status, bankId: "", documents: [] })}
                        dealer_id={userDetails && userDetails.organization?.toLowerCase() === "dealer" ? userDetails._id : ""}
                        setToaster={(data) => setToaster(data)}
                    />
                )
            }


            <CreateBankAccountPopup
                dealer_id={sharedReducerData.lenderSelectedDealerId ? sharedReducerData.lenderSelectedDealerId : (props?.selectedDealerId ? props?.selectedDealerId : sharedReducerData?.lenderSelectedSupplierDetails?._id)}
                setToaster={(data) => setToaster(data)}
                refreshData={() => refreshBankAccounts()}
                showModal={addBankModal}
                from={props.from}
                closeModal={() => setAddBankModal(false)}
                actionType="create"
            />
        </div>
    );

}

export default React.memo(BankSelection);